<mat-chip (click)="this.callbackFunction && this.callbackFunction()" [ngClass]="chipClass" class="chip">{{label}}
  <mat-icon *ngIf="chipClass.includes('clear')">cancel</mat-icon>
</mat-chip>
